'use client';

import Image from "next/image";

interface AgentCardProps {
  icon: string;
  name: string;
  description: string;
  onClick?: () => void;
  isSelected?: boolean;
  iconColor?: string;
}

export default function AgentCard({ 
  icon, 
  name, 
  description, 
  onClick,
  isSelected = false,
  iconColor
}: AgentCardProps) {
  const isImageUrl = icon.startsWith('/') || icon.startsWith('http');

  return (
    <button
      onClick={onClick}
      className={`
        w-45 h-[100px] p-4 rounded-xl
        bg-white/5 border transition-all duration-200
        flex flex-col items-start gap-2 text-left relative overflow-hidden group
        hover:bg-white/8 hover:border-primary-purple/50 hover:-translate-y-0.5
        active:scale-[0.98]
        ${isSelected 
          ? 'border-transparent bg-linear-to-r from-primary-purple/20 to-primary-pink/20 shadow-glow-purple' 
          : 'border-white/10'
        }
      `}
    >
      {/* 选中时的光晕背景 */}
      {isSelected && (
        <div className="absolute inset-0 bg-primary-purple/10 blur-xl -z-10" />
      )}

      {/* 图标 - 36px */}
      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 border border-white/5 group-hover:border-white/10 transition-colors">
        {isImageUrl ? (
          <Image 
            src={icon} 
            alt={name} 
            width={24} 
            height={24} 
            className="w-6 h-6 object-contain"
          />
        ) : (
          <span 
            className="text-xl leading-none"
            style={iconColor ? { color: iconColor } : undefined}
          >
            {icon}
          </span>
        )}
      </div>
      
      {/* 文字区域 */}
      <div className="w-full mt-auto">
        <h3 className="text-[15px] font-medium text-white truncate">{name}</h3>
        <p className="text-[11px] text-white/50 line-clamp-1 mt-0.5">{description}</p>
      </div>
    </button>
  );
}

// 默认智能体列表 - 按规范定义
export const defaultAgents = [
  { 
    icon: "🎯", 
    name: "陪练沙盒", 
    description: "交互式培训、模拟场景练习",
    code: "peilianshahezi",
    iconColor: "#FCA164" // 橙色
  },
  { 
    icon: "💰", 
    name: "核价大师", 
    description: "成本核算、价格分析",
    code: "hejiadashi",
    iconColor: "#FFD700" // 金色
  },
  { 
    icon: "📊", 
    name: "经营会计", 
    description: "财务分析、经营数据管理",
    code: "jingyingkuaiji",
    iconColor: "#4A90D9" // 蓝色
  },
  { 
    icon: "👥", 
    name: "人力资源", 
    description: "人事管理、招聘分析",
    code: "renliziyuan",
    iconColor: "#FF69B4" // 粉色
  },
];
